import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import '../styles/LoginPage.css';

export default function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('Ungültiger Bestätigungslink.');
            return;
        }
        api.get('/auth/verify-email', { params: { token } })
            .then(res => {
                setStatus('success');
                setMessage(res.data.message);
            })
            .catch(err => {
                setStatus('error');
                setMessage(
                    err.response?.data?.detail ||
                    'Der Bestätigungslink ist ungültig oder abgelaufen.'
                );
            });
    }, []);

    return (
        <div className="login-container">
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', marginBottom: 24 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--color-primary)', display: 'inline-block' }} />
                <span style={{ fontWeight: 700, fontSize: 18, color: 'var(--color-text)' }}>Scalewisp</span>
            </Link>

            {status === 'loading' && (
                <p style={{ color: 'var(--color-text-secondary)', fontSize: 14 }}>E-Mail wird bestätigt…</p>
            )}

            {status === 'success' && (
                <>
                    <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em' }}>
                        E-Mail bestätigt
                    </h2>
                    <p style={{ margin: '0 0 24px', color: 'var(--color-text-secondary)', fontSize: 14 }}>
                        {message}
                    </p>
                    <Link
                        to="/login"
                        className="button"
                        style={{ display: 'block', textAlign: 'center', background: 'var(--color-primary)', color: '#fff', padding: '10px', fontWeight: 600, fontSize: 15, borderRadius: 8, textDecoration: 'none' }}
                    >
                        Jetzt anmelden
                    </Link>
                </>
            )}

            {status === 'error' && (
                <>
                    <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em' }}>
                        Bestätigung fehlgeschlagen
                    </h2>
                    <p className="login-error" style={{ margin: '0 0 16px' }}>{message}</p>
                    <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--color-text-secondary)' }}>
                        <Link to="/register" style={{ color: 'var(--color-primary)', fontWeight: 600, textDecoration: 'none' }}>
                            Zurück zur Registrierung
                        </Link>
                    </p>
                </>
            )}
        </div>
    );
}
